/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Voice_Manager_Render_Failed_ToastInputs */

const en_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio Rendering Failed. ${i?.error}`)
};

const fr_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec du rendu audio. ${i?.error}`)
};

const de_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audiowiedergabe fehlgeschlagen. ${i?.error}`)
};

const it_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendering audio non riuscito. ${i?.error}`)
};

const ru_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при рендеринге звука. ${i?.error}`)
};

const es_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la representación de audio. ${i?.error}`)
};

const zh_cn2_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音频渲染失败。${i?.error}`)
};

const ja_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オーディオのレンダリングに失敗しました。${i?.error}`)
};

const hi_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो रेंडरिंग विफल रही। ${i?.error}`)
};

const pt_pt2_voice_manager_render_failed_toast = /** @type {(inputs: Voice_Manager_Render_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na renderização de áudio. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Audio Rendering Failed. {error}" |
*
* @param {Voice_Manager_Render_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_render_failed_toast = /** @type {((inputs: Voice_Manager_Render_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Render_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_render_failed_toast(inputs)
	if (locale === "de") return de_voice_manager_render_failed_toast(inputs)
	if (locale === "it") return it_voice_manager_render_failed_toast(inputs)
	if (locale === "ru") return ru_voice_manager_render_failed_toast(inputs)
	if (locale === "es") return es_voice_manager_render_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_render_failed_toast(inputs)
	if (locale === "ja") return ja_voice_manager_render_failed_toast(inputs)
	if (locale === "hi") return hi_voice_manager_render_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_render_failed_toast(inputs)
	return en_voice_manager_render_failed_toast(inputs)
});